import React from 'react';

const InputFormWrapper = ({
  children,
  required = false,
  width = 3,
  label = '',
  className = '',
  ...rest
}) => {
  const widthInput = 12 - width;
  return (
    <div className={`row m-2 ${className}`}>
      <div className={`col-${width}`}>
        <label className="label-block">
          {label} {required && <span className="required">*</span>}
        </label>
      </div>
      <div className={`col-${widthInput}`} {...rest}>{children}</div>
    </div>
  );
};

export default InputFormWrapper;



// WEBPACK FOOTER //
// ./foody/src/components/Common/InputFormWrapper.jsx